<template>
  <el-form
    ref="contactPersonForm"
    :key="formKey"
    label-position="top"
    :model="contactPerson"
    :rules="rules"
  >
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item
          label="Név"
          prop="name"
        >
          <el-input
            v-model="contactPerson.name"
          />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          label="Beosztás"
          prop="position"
        >
          <el-input
            v-model="contactPerson.position"
          />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item
          label="Mobil"
          prop="mobile"
        >
          <el-input
            v-model="contactPerson.mobile"
          />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          label="Honlap"
          prop="website"
        >
          <el-input
            v-model="contactPerson.website"
          />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item
          label="Email"
          prop="email"
        >
          <el-input
            v-model="contactPerson.email"
          />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          label="Számla email"
          prop="invoice_email"
        >
          <el-input
            v-model="contactPerson.invoice_email"
          />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item
          prop="webshop_access"
        >
          <el-checkbox
            v-model="contactPerson.webshop_access"
            @change="onWebshopAccessChange"
          >
            Webshop hozzáférés
          </el-checkbox>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          prop="send_invoice_email"
        >
          <el-checkbox
            v-model="contactPerson.send_invoice_email"
          >
            Számla küldése Email -ben
          </el-checkbox>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row
      :gutter="20"
    >
      <el-col :span="12">
        <el-form-item
          prop="is_supplier_contact"
        >
          <el-checkbox
            v-model="contactPerson.is_supplier_contact"
          >
            Beszállítói kapcsolattartó
          </el-checkbox>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          prop="is_customer_contact"
        >
          <el-checkbox
            v-model="contactPerson.is_customer_contact"
          >
            Vevői kapcsolattartó
          </el-checkbox>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row
      :gutter="20"
    >
      <el-col :span="12">
        <el-form-item
          label="Felhasználónév"
          prop="username"
        >
          <el-input
            v-model="contactPerson.username"
            :disabled="!contactPerson.webshop_access"
          />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          label="Jelszó"
          prop="password"
        >
          <el-input
            type="password"
            v-model="contactPerson.password"
            :disabled="!contactPerson.webshop_access"
          />
        </el-form-item>
      </el-col>
    </el-row>
    <hr />
    <el-row :gutter="20">
      <el-col :span="24">
        <el-form-item
          prop="test_person"
        >
          <el-checkbox
            v-model="contactPerson.test_person"
          >
            <span class="red">!! Teszt felhasználó !!</span>
          </el-checkbox>
          <p>Teszt környezeten kizárólag az itt megjelölt felhasználók kapnak számla értesítő E-mailt,<br/>más tekintetben nincs különbség!</p>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
  export default {
    props: ['defaultContactPerson', 'formType'],
    data() {
      return {
        contactPerson: {
          webshop_access: false,
        },
        formKey: 0,
        rules: {
          name: [
            { required: true, message: 'Név megadása kötekező', trigger: 'change' },
          ],
        },
      };
    },
    watch: {
      defaultContactPerson: {
        handler(newVal) {
          this.contactPerson = Object.assign({}, newVal);
          this.onWebshopAccessChange(this.contactPerson.webshop_access);
        },
        deep: true,
      },
    },
    methods: {
      render() {
        this.contactPerson = {
          webshop_access: false,
        };
        this.rules = {
          name: [
            { required: true, message: 'Név megadása kötekező', trigger: 'change' },
          ],
        };
        this.$refs.contactPersonForm.resetFields();
        this.formKey++;
      },
      onWebshopAccessChange(value) {
        if (value) {
          this.rules.email = [
            { required: true, message: 'Email megadása kötekező', trigger: 'change' },
          ];
          this.rules.password = [
            { required: true, message: 'Jelszó megadása kötekező', trigger: 'change' },
          ];
          this.rules.username = [
            { required: true, message: 'Felhasználónév megadása kötekező', trigger: 'change' },
          ];
        } else {
          delete this.rules.email;
          delete this.rules.username;
          delete this.rules.password;
        }
        this.formKey++;
      }

    },
    async mounted() {
      this.render();
      if (this.formType !== 'add') {
        this.contactPerson = Object.assign({}, this.defaultContactPerson);
        this.onWebshopAccessChange(this.contactPerson.webshop_access);
      }
    }
  };
</script>
